import { IMAGE_SERVICE_URL } from 'config';

export const IMAGE_SERVICE_V1_URL = `${IMAGE_SERVICE_URL}/api/v1/image`;

export const IMAGE_SERVICE_V1_BACKGROUND_URL = `${IMAGE_SERVICE_V1_URL}/background`;

export const IMAGE_SERVICE_V1_BACKGROUND_BLOB_URL = `${IMAGE_SERVICE_V1_BACKGROUND_URL}/blob`;
